import axios from 'axios';

axios.defaults.baseUrl = 'http://localhost:3000/';